<div class="flex flex-col gap-3">
  <div class="text-general-title">
    <div class="text-(--color-text-primary)" mat-dialog-title>
      {{ 'quotation.fieldNames.deleteProcedure' | translate }}
    </div>
  </div>
  <div mat-dialog-content class="text-general text-center">
    {{ 'quotation.fieldNames.deleteProcedureConfirm' | translate }}
  </div>
  <div mat-dialog-actions class="flex justify-center gap-3">
    <button matButton="filled" class="button-general-light" (click)="closeModal()">
      {{ 'general.cancel' | translate }}
    </button>
    <button matButton="filled" class="button-general-light" (click)="deleteFormality()">
      {{ 'general.save' | translate }}
    </button>
  </div>
</div>
